import request from '@/utils/request'
const BASE_URL = '/malls'

export default {
  codelogin(code) {
    return request({
      url: BASE_URL + '/codelogin',
      method: 'post',
      data: { code: code }
    })
  },
}